<ng-template #noPermission><boma-unauthed></boma-unauthed></ng-template
><ng-container
  *permissionChecker="
    { permissions: ['add-notes'], requirement: 'all' };
    else noPermission
  "
>
  <ng-container *ngIf="notes.length">
    <div *ngFor="let note of notes" class="note mb-2">
      <div class="card-user">
        <strong>{{ note.user.name }} {{ note.user.surname }}</strong>
        <!-- TODO Replace with friendly Date -->
        {{ note?.createdAt | date: 'dd/MM/yyyy, HH:mm:ss' }}
      </div>
      <div class="box-section p-1" [title]="note.identifier">
        <div class="card-title">{{ note.title }}</div>
        <div class="card-content">{{ note.content }}</div>
      </div>
    </div>
  </ng-container>

  <div class="box-section">
    <form
      [formGroup]="noteFormGroup"
      (ngSubmit)="createNote()"
      class="p-2 grid formgrid"
    >
      <div class="field col-12" *ngIf="showTitle">
        <label for="title">Title</label>
        <input
          type="text"
          id="title"
          formControlName="title"
          class="p-inputtext w-full"
          [ngClass]="{
            'p-invalid':
              noteFormGroup.get('title').invalid &&
              noteFormGroup.get('title').touched
          }"
        />
        <div
          class="p-error"
          *ngIf="
            noteFormGroup.get('title').invalid &&
            noteFormGroup.get('title').touched
          "
        >
          Title is required
        </div>
      </div>
      <div class="field col-12">
        <label for="content">Comment</label>
        <span class="p-fluid">
          <textarea
            id="content"
            formControlName="content"
            class="p-inputtext p-inputtextarea"
            [ngClass]="{
              'p-invalid':
                noteFormGroup.get('content').invalid &&
                noteFormGroup.get('content').touched
            }"
          ></textarea>
        </span>
        <div
          class="p-error"
          *ngIf="
            noteFormGroup.get('content').invalid &&
            noteFormGroup.get('content').touched
          "
        >
          Content is required
        </div>
      </div>
      <div class="field col-12">
        <button
          type="submit"
          class="p-button p-button-primary"
          [disabled]="!noteFormGroup.valid"
        >
          Create Comment
        </button>
      </div>
    </form>
  </div>
</ng-container>
